/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import { ClientId, DivisionId, SenderId, SenderName, PrevilageId } from '../../helper/HelperAuth'
import UploadFile from '../../store/action/CheckContact/Upload'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import ActionFetchAllClient from '../../store/action/Client/FetchAll'
import ActionFetchAllDivision from '../../store/action/Division/FetchAll'
import ActionFetchSender from '../../store/action/Sender/FetchAll'
import chargeSample from '../../upload_template/checkcontact.txt';
import ActionGetAccessModule from '../../store/action/AccessModule/Fetch'
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'
import Swal from 'sweetalert2'

class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      params: fromJS({}),
      form: fromJS({
        "selected-file": null,
        "upload-completed": false,
        "client-id": null,
        "division-id": null,
        "sender-id": '',
        "sender-name": '',
        "file-name": '',
        "schedule-date": '',
        "schedule-time": '',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      actionId: '',
      disabledHead: false,
      disrest: true,
      filetype: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOnFileChanged = this.handleOnFileChanged.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleCancelFile = this.handleCancelFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentDidMount() {
    let formVal = this.state.form
    await this.props.actionGetAccessModule(PrevilageId);
    this.props.actionFetchAllClient()
    let restrict = this.handleActionId()
    if (restrict == 5) {
      await this.props.actionFetchAllDivision(ClientId, 'Check Contact')
      this.props.actionFetchSender(ClientId)
      formVal = formVal.set("client-id", ClientId)
      formVal = formVal.set("division-id", DivisionId)
      formVal = formVal.set("sender-id", SenderId)
      this.setState({
        form: formVal,
        disrest: true,
        actionId: restrict
      })
    }else{
      this.setState({
        disrest: false
      })
    }

  }
  async handleSubmit() {
    const form = this.state.form;
    var file = this.state.form.get('selected-file');
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderId = this.state.form.get('sender-id');
    var varSenderWord = this.state.form.get('sender-name');
    var varScheduleDate = this.state.form.get('schedule-date');
    var varScheduleTime = this.state.form.get('schedule-time');

    if (form.get("client-id") === '' || form.get("client-id") === null || form.get("client-id") === undefined) {
      toast.error('Client cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (form.get("division-id") === '' || form.get("division-id") === null || form.get("division-id") === undefined) {
      toast.error('Division cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (form.get("sender-id") === '' || form.get("sender-id") === null || form.get("sender-id") === undefined) {
      toast.error('Sender cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (varScheduleDate === '' || varScheduleDate === null || varScheduleDate === undefined) {
      toast.error('Schedule Date cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (varScheduleTime === '' || varScheduleTime === null || varScheduleTime === undefined) {
      toast.error('Schedule Time cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (form.get("file-name") === '' || form.get("file-name") === null || form.get("file-name") === undefined) {
      toast.error('Upload file first', toast.POSITION.TOP_RIGHT);
      return false
    }
    var response = await this.props.actionUploadFile(file, varClientId, varDivisionId, varSenderId, varSenderWord, varScheduleDate, varScheduleTime);
  
    if (response.ok) {
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
    }
  }
  handleActionId() {
    let array = []
    let action = 0;
    let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
    {
      menuPrev.map((data, i) =>
        array.push({
          'menu-name': data.get('menu-name'),
          'action-id': data.get('action-id')
        })

      )
    }

    for (let i = 0; i < array.length; i++) {
      if (array[i]['menu-name'] === 'Check Contact') {
        action = array[i]['action-id'];
        this.state.action_id = array[i]['action-id'];
      }
    }
    return action;
  }

  handleCancelFile() {
    var changeVals = this.state.form;
    var statDis = true;
    var actionIdVar = this.state.actionId;

    if (actionIdVar != 5) {
      changeVals = changeVals.set('client-id', null).set('sender-id', null).set('division-id', null).set('sender-word', null)
      statDis = false;
    }
    changeVals = changeVals.set('file-name', '');
    changeVals = changeVals.set('selected-file', null);
    changeVals = changeVals.set('upload-completed', false);

    this.setState({ form: changeVals, disabled: false, disabledHead: statDis })
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);

    if (field === "client-id") {
      this.props.actionFetchAllDivision(value);
  	 this.props.actionFetchSender(value);
      if (value === '' || value === undefined || value === null) {
        formVal = formVal.set(field, value).set('sender-id', null).set('division-id', null)
      } else {
        formVal = formVal.set(field, value)
      }
    }

    if (field === "division-id") {
      if (value === '' || value === undefined || value === null) {
        formVal = formVal.set(field, value).set('sender-id', null)
      }
    }
    if (field === "sender-id") {
      formVal = formVal.set(field, value).set('sender-name', label)
    }
    this.setState({ form: formVal })
  }



  async handleUploadFile() {
    var file = this.state.form.get('selected-file');
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderId = this.state.form.get('sender-id');
    var varSenderWord = this.state.form.get('sender-name');
    var varScheduleDate = this.state.form.get('schedule-date');
    var varScheduleTime = this.state.form.get('schedule-time');
    if(this.state.filetype !== "text"){
      toast.error('Only accepted file with extension .txt', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (varClientId && varDivisionId && varSenderId && file) {
      if (varScheduleDate === '' || varScheduleDate === null || varScheduleDate === undefined) {
        toast.error('Schedule Date cannot be empty!', toast.POSITION.TOP_RIGHT);
        return false
      }
      if (varScheduleTime === '' || varScheduleTime === null || varScheduleTime === undefined) {
        toast.error('Schedule Time cannot be empty!', toast.POSITION.TOP_RIGHT);
        return false
      }
      Swal.fire({
        title: 'Do you want upload this file',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.senddata()
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', '', 'info')
          confirm = false
          return false
        }
      })
    } else {
      toast.error('Client, Division, Sender and file must be filled', toast.POSITION.TOP_RIGHT);
    }
  }

  async senddata() {
    var file = this.state.form.get('selected-file');
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderId = this.state.form.get('sender-id');
    var varSenderWord = this.state.form.get('sender-name');
    var varScheduleDate = this.state.form.get('schedule-date');
    var varScheduleTime = this.state.form.get('schedule-time');
    var response = await this.props.actionUploadFile(file, varClientId, varDivisionId, varSenderId, varSenderWord, varScheduleDate, varScheduleTime);
    if (response.get('success')) {
      let newForm = this.state.form;
      newForm = newForm.set('file-name', response.get('file-name'));
      newForm = newForm.set('upload-completed', true);
      this.setState({
        form: newForm,
        disabled: true,
        disabledHead: true
      })
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.handleCancel()
    } else {
      toast.error('Upload Failed', toast.POSITION.TOP_RIGHT);
    }
  }
  handleCancel() {
    this.props.handleCancelForm(false);
  }

  handleOnFileChanged() {
    let newForm = this.state.form;
    newForm = newForm.set("selected-file", event.target.files[0]);
    let type = event.target.files[0].type.split("/")
    type = type[0]
    this.setState({
      form: newForm,
      filetype:type
    })
  }

  render() {
    const { form, errors } = this.state;
    let disable = ''
    if (this.state.disrest == true) {
      disable = this.state.disrest
    } else {
      disable = this.state.disabledHead
    }
    return (

      <div className="clearfix">
        <div className="card">
          <div className="body clearfix">
            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <a className="btn btn-success" href={chargeSample} download="checkcontact.txt">DOWNLOAD FILE CHECK CONTACT</a>
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Client</span>
              <div className="col-sm-10">
                <ComboboxInput
                  field='client-id'
                  value={form.get('client-id')}
                  options={fromJS({
                    'source': this.props.Clientall,
                    'value': 'client-id',
                    'label': 'client-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Client"
                  // disabled={this.state.disabled}
                  disabled={disable}
                  hasError={errors.has('client-id')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Division</span>
              <div className="col-sm-10">
                <ComboboxInput
                  field='division-id'
                  value={form.get('division-id')}
                  options={fromJS({
                    'source': this.props.Divisionall,
                    'value': 'division-id',
                    'label': 'division-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Division"
                  // disabled={this.state.disabled}
                  disabled={disable}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2">Sender</span>
              <div className="col-sm-10">
                <ComboboxInput
                  field='sender-id'
                  value={form.get('sender-id')}
                  options={fromJS({
                    'source': this.props.Senders,
                    'value': 'sender-id',
                    'label': 'sender-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Sender"
                  // disabled={this.state.disabled}
                  disabled={disable}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Schedule Date</span>
              <div className="col-sm-10">
                <DatePickerInput
                  convertvalue
                  minDate={new Date()-1}
                  field="schedule-date"
                  dateFormat="yyyy-MM-dd"
                  value={form.get('schedule-date')}
                  onChange={(field, date) => this.handleChange(field, date)}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Schedule Time</span>
              <div className="col-sm-10">
                <DatePickerInput
                  className="business-hour-time"
                  type="Time"
                  convertvalue
                  field="schedule-time"
                  value={form.get('schedule-time')}
                  dateFormat="HH:mm:ss"
                  onChange={(field, date) => this.handleChange(field, date)}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">File Upload</span>
              <div className="col-sm-10">
                <input className="form-control" type="file" name="file" disabled={this.state.disabled} onChange={this.handleOnFileChanged} />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <button type="button"
                  className="btn btn-info"
                  disabled={this.state.disabled}
                  onClick={this.handleUploadFile}>
                  Upload
                </button>
                {/* <button type="button"
                    className="btn btn-danger"
                    disabled={!this.state.disabled}
                    onClick={this.handleCancelFile}>
                    Change
                </button>
                  <label className="lbl-info">
                    {"filename : " + form.get('file-name')}
                  </label> */}
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-6">
                <button type="button"
                  className="btn btn-width btn-danger"
                  value="Cancel"
                  onClick={this.handleCancel}>
                  Cancel
                </button>
                {/* <button type="button"
                    disabled={!form.get("upload-completed")}
                    className=""
                    onClick={this.handleSubmit}>
                    Submit
              </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }



}


export default connect(
  (state) => {
    return {
      Clientall: state.user.clientall,
      Divisionall: state.user.divisionall,
      Senders: state.user.senders,
      accessmodules: state.user.accessmodules,
    }
  },
  dispatch => bindActionCreators({
    actionFetchAllClient: ActionFetchAllClient,
    actionFetchAllDivision: ActionFetchAllDivision,
    actionFetchSender: ActionFetchSender,
    actionGetAccessModule: ActionGetAccessModule,
    actionUploadFile: UploadFile
  }, dispatch),
)(Form);